import { render, staticRenderFns } from "./MySpaceRemindersWidget.vue?vue&type=template&id=597a451a&scoped=true&"
import script from "./MySpaceRemindersWidget.vue?vue&type=script&lang=js&"
export * from "./MySpaceRemindersWidget.vue?vue&type=script&lang=js&"
import style0 from "./MySpaceRemindersWidget.vue?vue&type=style&index=0&id=597a451a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597a451a",
  null
  
)

export default component.exports